export default {
  SECTION_WIDGET_PRODUCT: {
    layout01: {
      container: {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 4,
              tablet: 4,
              mobile: 2,
            }
          },
          66.67: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          58.33: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          50: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          41.67: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 2,
            }
          },
          33.33: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 2,
            }
          },
          25: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 2,
            }
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
        },
      },
      'container-fluid': {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 6,
              tablet: 4,
              mobile: 2,
            }
          },
          66.67: {
            allow: true,
            item: {
              desktop: 3,
              tablet: 2,
              mobile: 2,
            }
          },
          58.33: {
            allow: true,
            item: {
              desktop: 3,
              tablet: 2,
              mobile: 2,
            }
          },
          50: {
            allow: true,
            item: {
              desktop: 3,
              tablet: 2,
              mobile: 2,
            }
          },
          41.67: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          33.33: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          25: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 2,
              mobile: 2,
            }
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
        },
      },
    },
    layout02: {
      container: {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 3,
              tablet: 3,
              mobile: 2,
            },
          },
          66.67: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          58.33: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          50: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          41.67: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 2,
            },
          },
          33.33: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 2,
            },
          },
          25: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
        },
      },
      'container-fluid': {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 4,
              tablet: 4,
              mobile: 2,
            },
          },
          66.67: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          58.33: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          50: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          41.67: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          33.33: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            },
          },
          25: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
        },
      },
    },
    layout03: {
      container: {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          66.67: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          58.33: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          50: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          41.67: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          33.33: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          25: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
        },
      },
      'container-fluid': {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          66.67: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          58.33: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          50: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 1,
            },
          },
          41.67: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          33.33: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          25: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            },
          },
        },
      },
    },
    layoutSlide: {
      container: {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 4,
              tablet: 4,
              mobile: 2,
            }
          },
          66.67: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          58.33: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          50: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          41.67: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 2,
            }
          },
          33.33: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 1,
              mobile: 2,
            }
          },
          25: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 2,
              mobile: 2,
            }
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
        },
      },
      'container-fluid': {
        cellWidth: {
          100: {
            allow: true,
            item: {
              desktop: 6,
              tablet: 4,
              mobile: 2,
            }
          },
          66.67: {
            allow: true,
            item: {
              desktop: 3,
              tablet: 2,
              mobile: 2,
            }
          },
          58.33: {
            allow: true,
            item: {
              desktop: 3,
              tablet: 2,
              mobile: 2,
            }
          },
          50: {
            allow: true,
            item: {
              desktop: 3,
              tablet: 2,
              mobile: 2,
            }
          },
          41.67: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          33.33: {
            allow: true,
            item: {
              desktop: 2,
              tablet: 2,
              mobile: 2,
            }
          },
          25: {
            allow: true,
            item: {
              desktop: 1,
              tablet: 2,
              mobile: 2,
            }
          },
          20: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
          16.66: {
            allow: false,
            item: {
              desktop: null,
              tablet: null,
              mobile: null,
            }
          },
        },
      },
    },
  },
};
